module.exports = __webpack_public_path__ + "static/CardOfDarkness3-c4f730bc0ac515edb199a72badd48a38.webp";